
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form13";
const form13State = namespace("Form13");

import Form13ProcessHeader from "@/components/process/Form13/components/Form13ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { packageInfoType } from '@/types/Information';
import { form13StatusInfoType } from '@/types/Information/Form13';

@Component({
    components:{
        Form13ProcessHeader,
        Spinner
    }
})
export default class SubmitForm13 extends Vue {

    @form13State.State
    public currentConsentOrderExtendTimeId: string;

    stepsCompleted = {} as form13StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }    

    public savePdf(){        
        const pdfType = "FORM"
        const pdfName ="Form13"
        const url = '/form13/form-print/'+this.currentConsentOrderExtendTimeId+'/?pdf_type='+pdfType
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);          

        },err => {
            console.error(err);
        });
    }     

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
